import { render, staticRenderFns } from "./ProductionOrder.vue?vue&type=template&id=0d45e582&scoped=true&"
import script from "./ProductionOrder.vue?vue&type=script&lang=js&"
export * from "./ProductionOrder.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOrder.vue?vue&type=style&index=0&id=0d45e582&scoped=true&lang=css&"
import style1 from "./ProductionOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d45e582",
  null
  
)

export default component.exports